export default {
      id: "icon-download-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-download",
      toString: function () {
        return this.url;
      }
    }